export const radar = {
    label: {
        visible: !1,
        offset: 5,
        style: {
            lineWidth: 2,
            stroke: {
                type: "palette",
                key: "backgroundColor"
            }
        }
    },
    point: {
        style: {
            symbolType: "circle"
        }
    }
};
//# sourceMappingURL=radar.js.map
